import * as React from "react";
import { Fragment, FunctionComponent, useState, useContext } from "react";
import { Navigate } from "react-router-dom";

//MUI
import Toolbar from "@mui/material/Toolbar";
import { createTheme, ThemeProvider } from "@mui/material/styles";

//Custom Components
import PublicHeader from "@/ui/Header/PublicHeader";
import Footer from "@/ui/Footer/Footer";
import UserContext from "@/components/UserContext/UserContext";
import DialogProvider from "@/ui/DialogContext/DialogProvider";
import DialogContainer from "@/ui/DialogContext/DialogContainer";
import ThemeContext from "@/components/ThemeContext/ThemeContext";
import { authService } from "@/services/authService";
import Loader from "@/ui/Loader/Loader";
import { sifrarnici } from "@/lib/sifrarnici";
import useTitle from '@/components/useTitle';

import { ThemeContextType, Theme } from "@/@types/context/ThemeContext";


//Background Image
import Image from "@/images/bkg/hgss-background.jpg";
import Bg_about from "@/images/bkg/bg_about.png"

//Types
import { IPublicPage } from "@/@types/ui/PublicPage";

const AUTH_TOKEN = "auth_token";

const PublicPage: FunctionComponent<IPublicPage> = (props) => {
  const userContext = useContext(UserContext);
  const themeContext = useContext(ThemeContext) as ThemeContextType;

  const [refresh, setRefresh] = useState(false);

  useTitle();
  
  const komentar_guid = new URLSearchParams(window.location.search).get("komentar");

  const accessToken = localStorage.getItem(AUTH_TOKEN);
  const hasAccessToken = accessToken !== null && accessToken.length > 0 ? true : false;

  const knowsWhoAmI = userContext !== null && userContext.email !== null && typeof userContext.email === "string" && userContext.email.length > 0 ? true : false;
  const isPublic = accessToken === sifrarnici.publicToken;
  const isAuthenticated = hasAccessToken && knowsWhoAmI && !isPublic;

  if (hasAccessToken && !isPublic && !knowsWhoAmI) {
    authService
      .whoAmI()
      .then((user) => {
        if (user === undefined) {
          // localStorage.removeItem(AUTH_TOKEN);
          localStorage.setItem(AUTH_TOKEN, sifrarnici.publicToken);
          window.location.reload();
        } else {
          if (userContext !== null) {
            userContext.setUserData(user);
          }
        }
      })
      .catch((err) => {
        console.warn(err);
        // localStorage.removeItem(AUTH_TOKEN);
        localStorage.setItem(AUTH_TOKEN, sifrarnici.publicToken);
        window.location.reload();
      })
  } else if (!hasAccessToken) {
    localStorage.setItem(AUTH_TOKEN, sifrarnici.publicToken);
    setRefresh(r => !r);
  }

  if (isAuthenticated && komentar_guid) {
    return  <Navigate to={{ pathname: userContext?.getDefaultUrl()}} state={{komentar_guid: komentar_guid}} />;
  } else if (hasAccessToken && !isPublic && !knowsWhoAmI) {
    return <Loader open={true} />;
  } else {

    return (
      <ThemeProvider theme={themeContext.publicTheme}>
        <DialogProvider>
          <PublicHeader />
          
          <main id="content-wrapper" className="public-content-wrapper" style={{ 
            flexGrow: 1,
            scrollbarColor: ""+themeContext.publicTheme.palette.primary.main+" #ffffff",
           }}>

            <Toolbar variant="dense" sx={{ margin: 1 }} />
            <div
              id="content"
              style={!props.overrideBgImage?{
                backgroundImage: `url(${Image})`,
                objectFit: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover"
              }: {
                backgroundImage: `url(${Bg_about})`,
                backgroundRepeat: "repeat-y",
                backgroundPosition: "right top",
                display: "flex",
                flexDirection: "column"
              }}
            >
              {props.children}
            </div>
          </main>
          {/* <Footer /> */}
          <DialogContainer />
        </DialogProvider>
      </ThemeProvider>
    );
  }
};

export default PublicPage;
